<template>
  <div class="main-container">
    <div class="form-register">
      <div style="display: flex; justify-content: center; margin-bottom: 10px">
        <img alt="Atosa"
             style="width:80px; height:80px; background-color:white; border-radius: 50vh; padding:3px !important;"
             src="/static/img/logo.png"/>
      </div>
      <div style="text-align: center; padding: 0 10px">
        <strong style="text-transform: uppercase; font-size: 18px; color: #125570;">
          {{ $t('base.sign_up_title') }}
        </strong>
      </div>
      <div style="margin-top: 30px">
        <form @submit="m__try_register">
          <div>
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.full_name') }}
            </p>
            <el-input v-model="register_form.form.name" :placeholder="$t('input.full_name')"></el-input>
          </div>

          <div style="margin-top: 15px">
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.email_address') }}</p>
            <el-input v-model="register_form.form.email" :placeholder="$t('input.email_address')"></el-input>
          </div>

          <div style="margin-top: 15px">
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.phone_number') }}
            </p>
            <el-input v-model="register_form.form.phone" :placeholder="$t('input.phone_number')"></el-input>
          </div>
          <div style="margin-top: 10px">
            <strong style="font-size: 14px">*{{ $t('base.correct_phone_number_message') }}.</strong>
          </div>
          <input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response">

          <div style="margin-top: 25px">
            <el-button type="summit" class="full-w" :loading="register_form.loading"
                       @click="m__try_register">
              {{ $t('base.register_account') }}
            </el-button>
          </div>

          <div style="margin-top: 35px; text-align: center">
            <strong style="font-size: 14px">{{ $t('base.existed_account') }}? </strong>
            <a href="javascript:void(0)" @click="$router.push('/login')">
              <strong style="font-size: 14px" class="text-primary">{{ $t('base.login_now') }}</strong>
            </a>
          </div>

          <button type="submit" style="display: none;"/>
        </form>
      </div>
    </div>

    <div class="info-container">
      <div>
        <strong>{{ $t('base.join_shopee_ads_course') }}</strong>
        <a href="https://www.quangcaoshopee.com" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
      <div>
        <strong> {{ $t('base.learn_about_atosa') }}</strong>
        <a href="https://atosa.asia" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
    </div>

    <el-dialog width="800px" :close-on-click-modal="false" :visible.sync="success_dialog"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="text-align: center; margin-top: 30px">
          <strong style="font-size: 18px; color: tomato">
            {{ $t('base.register_success') }}
          </strong>
        </div>
        <div style="text-align: center; margin-top: 10px">
          <strong style="font-size: 14px;">
            {{ $t('base.pass_sent_to_email') }}
          </strong>
        </div>
        <div style="text-align: center; margin-top: 25px">
          <el-button type="primary" class="summit-button" @click="m__confirm_register_successfully">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'register-page',

  data() {
    return {
      register_form: {
        loading: false,
        form: {
          ip: '0.0.0.0',
          name: '',
          phone: '',
          email: '',
          response: '',
          mipee: false,
          sendo_like: false,
          atosa: true,
          captcha_version: 'v3'
        }
      },
      blocked: false,
      tip: false,
      ref: undefined,
      rkey: undefined,
      success_dialog: false
    }
  },

  // beforeCreate () {
  //   if (typeof this.$store.state.userInfo.username !== 'undefined') this.$router.push('/')
  // },

  mounted() {
    if (typeof this.$route.query.ref !== 'undefined') {
      this.ref = this.$route.query.ref
    }
    if (typeof this.$route.query.rkey !== 'undefined') {
      this.rkey = this.$route.query.rkey
    }

    this.m__check_ip()
  },

  methods: {
    async m__check_ip() {
      let ip = await this.m__get_ip()
      if (typeof ip !== 'undefined' && ip !== false) {
        this.register_form.form.ip = ip
        try {
          const response = await this.$http.post(this.API.register_check_ip, {
            ip: ip,
            ref: this.ref,
            rkey: this.rkey
          }, this.cf())
          this.blocked = !response.body.data.allow
        } catch (e) {
          this.blocked = true
        }
      } else {
        this.blocked = true
      }
    },

    async m__get_ip() {
      try {
        const response = await this.$http.get('https://api.ipify.org/?format=json')
        return response.body.ip
      } catch (e) {
        return false
      }
    },

    m__confirm_register_successfully() {
      this.success_dialog = false

      if (this.$route.query.redirect_url) {
        window.location.href = this.$route.query.redirect_url
      } else {
        window.location.href = '/'
      }
    },

    async m__reload_recaptcha() {
      this.register_form.form.response = await this.m__get_recaptcha_token()
    },

    m__get_recaptcha_token() {
      return new Promise(resolve => {
        grecaptcha.ready(async () => {
          const token = await grecaptcha.execute('6Lf3isIaAAAAAEEx5IBmKbf0Zdef-jGA8unA2XdB', {action: 'validate_captcha'})
          resolve(token)
        })
      })
    },

    async m__try_register(e) {
      e.preventDefault()

      await this.m__reload_recaptcha()

      if (this.register_form.form.name.trim().length < 4) {
        this.ntf_w(this.$t('required.full_name'))
        return 0
      }
      if (this.register_form.form.phone.trim().length < 4) {
        this.ntf_w(this.$t('required.phone_number'))
        return 0
      }
      if (this.register_form.form.email.length < 6 || !this.register_form.form.email.includes('@')) {
        this.ntf_w(this.$t('required.email_address'))
        return 0
      }

      try {
        await this.$confirm(this.$t('base.pass_sent_to_x_email_confirm', {x: this.register_form.form.email}), '', {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      try {
        this.register_form.loading = true
        await this.$http.post(this.API.register_final, {
          ...this.register_form.form,
          ref: this.ref,
          rkey: this.rkey
        }, this.cf())

        this.register_form.loading = false
        await this.m__reload_recaptcha()
        this.success_dialog = true
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.register_form.loading = false
        await this.m__reload_recaptcha()
      }
    }
  }
}
</script>

<style lang="scss">
.main-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url("/static/img/Group 483x3.png");
  //background-position-x: -10px;
  background-position-y: -60px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.form-register {
  width: 430px;
  position: absolute;
  top: 5%;
  //top: 50%;
  //transform: translate(0, -50%);
  //right: 130px;
  right: 8%;
  padding: 20px 30px;
  margin: auto;
  background: #FFFFFF;
  box-shadow: 0 2px 22px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 999;
}

.info-container {
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 0 0 15px;

  div strong {
    font-size: 13px;
    color: #041722;
    line-height: 30px;
  }

  div a {
    font-size: 13px;
    line-height: 30px;
    font-weight: bold;
  }
}

@media screen and (min-width: 1600px) {
  .form-register {
    top: 18%;
    right: 13%;
  }
}

@media screen and (min-width: 1900px) {
  .form-register {
    top: 18%;
    right: 13%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sign/register.vue